import React from "react";
import { ShieldCheck } from "lucide-react";
import { useContent } from "../lib/content";

export const WARRANTY_TEXT =
  "Set Up Home Theater warrants its installation labor for 5 years from the install date. If a TV mount we installed comes loose from the wall due to our workmanship, we will re-secure it at no charge. This covers our labor only. It does not cover the TV, the mount hardware, or any failure caused by misuse, tampering, modification by others, a child hanging or swinging on the TV or mount, wall damage from other causes, or acts of God. If Set Up Home Theater LLC closes or relocates outside its service area, this warranty ends on the date of closure or relocation.";

export const InstallWarranty = ({ dark = false, testId = "install-warranty", className = "" }) => {
  const { warranty: w } = useContent();
  return (
  <div data-testid={testId} className={className}>
    <h3 className={`flex items-center gap-2 font-bold text-sm ${dark ? "text-white" : "text-[#0a1f44]"}`}>
      <ShieldCheck className="w-4 h-4 text-[#3b9dff]" /> {w.heading}
    </h3>
    <p className={`mt-2 text-xs leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>{w.text}</p>
  </div>
  );
};
